<dialog-header [title]="'Choose a project'"></dialog-header>
<div class="projects-list oph-scroll-bar">
  @for (project of data.projects; track project) {
    <div class="project-item" (click)="onSelectProject(project)">
      <div [ngStyle]="{'background-color': project.color ? project.color : '#C7C2B6'}" class="project-name">
        {{ project.label ? project.label : 'Untitled' }}
      </div>
      <div>
        <mat-icon class="add">add</mat-icon>
      </div>
    </div>
  }
</div>
<button mat-flat-button (click)="openCreateProjectDialog()" *userHasRoleOption="rolePermissionOptions.Projects">
  <mat-icon class="add">add</mat-icon>
  <span class="button-text">Create new project</span>
</button>
